import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { AggregateOperationDtoAggregateFunctionEnum } from '../typescript-axios';


export const useAddMetricValidationSchema = (availableDataSources: string[]) => {
    const { t } = useTranslation();

    return Yup.object({
        metric: Yup.object({
            name: Yup.string()
                .required(t('validation.required'))
                .matches(/^[a-z0-9_]+$/, 'Only lowercase letters, numbers and underscores'),
            data_source_name: Yup.string()
                .oneOf(availableDataSources)
                .required(t('validation.required')),
            aggregate_operation: Yup.object({
                aggregate_function: Yup.string()
                    .oneOf(Object.values(AggregateOperationDtoAggregateFunctionEnum))
                    .required(t('validation.required')),
                column: Yup.object({
                    table: Yup.string().required(t('validation.required')),
                    column: Yup.string().required(t('validation.required')),
                }),
            }),
        }),
    })
};
